/**
 * Quotify → Google Ads conversion tracker (PARENT side) — USED.MARSHALL
 *
 * Quotify's quote form runs cross-origin in an iframe, so its own scripts
 * can't reach this page's Google tag. The Custom JavaScript pasted into the
 * used.marshall Quotify app (BLOCK 9) detects a successful submit and
 * postMessages MS_QUOTE_SUBMITTED up to this window. This script catches it
 * and fires the Google Ads lead conversion via the gtag already running on
 * the storefront (the same AW-1063513082 account as the new site).
 *
 * It also passes the customer's email/phone so Enhanced Conversions for Leads
 * can match the lead to the click.
 *
 * ── SETUP (once) ─────────────────────────────────────────────────────
 * 1. Google Ads (account 1063513082): Tools → Conversions → + New →
 *    "Website", category "Submit lead form", count "One", value "Don't use".
 *    Make a SEPARATE action from the new site's so you can tell the two stores
 *    apart in reporting.
 * 2. Open the action → "Use Google tag" → copy the send_to (looks like
 *    AW-1063513082/XXXXXXXX) and paste it into CONVERSION_SEND_TO below.
 * 3. Google Ads → Settings → Enhanced conversions → ON for leads (accept terms).
 * ─────────────────────────────────────────────────────────────────────
 *
 * NOTE: this assumes the gtag already on this storefront is configured for
 * AW-1063513082. Verify with Tag Assistant on a test submit — the hit should
 * show destination AW-1063513082 with your label.
 */
(function () {
  // ⬇️⬇️ PASTE THE USED-SITE CONVERSION LABEL HERE
  var CONVERSION_SEND_TO = 'AW-1063513082/Byb8CKPZ88ccEPrXj_sD';

  var LEAD_VALUE = 0;          // 0 = pure count; set a nominal number to weight bidding
  var CURRENCY = 'USD';
  var ALLOWED_ORIGIN_SUBSTRING = 'quotify';

  var fired = false;

  function alreadyCounted(id) {
    try {
      var key = 'ms_quote_conv_' + (id || 'x');
      if (sessionStorage.getItem(key)) return true;
      sessionStorage.setItem(key, '1');
      return false;
    } catch (_) { return false; }
  }

  function fireConversion(data) {
    if (fired) return;
    if (typeof window.gtag !== 'function') return;
    if (CONVERSION_SEND_TO.indexOf('REPLACE_WITH_USED_LABEL') !== -1) {
      try { console.warn('[quotify-conversion] set CONVERSION_SEND_TO before going live'); } catch (_) {}
      return;
    }
    fired = true;

    var userData = {};
    if (data && data.email) userData.email = String(data.email).trim().toLowerCase();
    if (data && data.phone) userData.phone_number = String(data.phone).replace(/[^\d+]/g, '');
    if (userData.email || userData.phone_number) {
      try { window.gtag('set', 'user_data', userData); } catch (_) {}
    }

    window.gtag('event', 'conversion', {
      send_to: CONVERSION_SEND_TO,
      value: LEAD_VALUE,
      currency: CURRENCY
    });
  }

  window.addEventListener('message', function (e) {
    var d = e && e.data;
    if (!d || typeof d !== 'object' || d.type !== 'MS_QUOTE_SUBMITTED') return;

    var origin = e.origin || '';
    if (origin.indexOf(ALLOWED_ORIGIN_SUBSTRING) === -1 && origin !== window.location.origin) {
      return;
    }

    if (alreadyCounted(d.id)) return;
    fireConversion(d);
  });
})();
